import React from 'react'
import { Provider as AtomProvider } from 'jotai'

const WrappedEl = ({ children }) => {
  return <AtomProvider>{children}</AtomProvider>
}

export default WrappedEl
